export const getFetchFilters = ({
  dataFilters,
  initialFetchFilters,
  managesTagsInternally,
  selectedTags,
  dataTags,
  selectedSort,
  initialSort,
}: {
  dataFilters: any;
  dataTags: any;
  initialFetchFilters: any;
  initialSort: any;
  managesTagsInternally: boolean;
  selectedSort: any;
  selectedTags: any;
}) => ({
  filters: dataFilters ?? initialFetchFilters ?? null,
  tags: (managesTagsInternally ? selectedTags : dataTags) ?? null,
  sort: selectedSort ?? initialSort ?? null,
});

export const getItemsSize = ({ fetchedData }: { fetchedData: any }) =>
  fetchedData?.pages?.[0]?.totalItems ?? 0;

export const getHasNoResult = ({
  isLoading,
  itemsSize,
}: {
  isLoading: boolean;
  itemsSize: number;
}) => !isLoading && itemsSize === 0;

export const getFetchNextPage = ({
  hasNextPage,
  fetchNextPage,
}: {
  fetchNextPage: () => void;
  hasNextPage: boolean;
}) => (hasNextPage ? fetchNextPage : () => {});

export const getScreenReaderStatus = ({
  isFetching,
  isLoading,
  itemsSize,
  hasNoResult,
  resultsFoundMessage = (itemsSize) =>
    n__(
      '%{itemsSize} match found',
      '%{itemsSize} matches found',
      itemsSize,
    ).i__({
      itemsSize: `${itemsSize}`,
    }),
  noResultsMessage = __('No matches found'),
}: {
  hasNoResult: boolean;
  isFetching: boolean;
  isLoading: boolean;
  itemsSize: number;
  noResultsMessage?: string;
  resultsFoundMessage?: (itemsSize: number) => string;
}) => {
  if (isFetching || isLoading) {
    return '';
  }

  if (itemsSize) {
    return resultsFoundMessage(itemsSize);
  }

  if (hasNoResult) {
    return noResultsMessage;
  }

  return null;
};

export const getEffectiveSortBy = ({
  isLoading,
  itemsSize,
  sortBy,
}: {
  isLoading: boolean;
  itemsSize: number;
  sortBy: any;
}) => (isLoading || itemsSize === 0 ? null : sortBy);
